import React from "react"
import { cn } from "~/lib/utils"

export interface FilterDropdownProps {
  show: boolean
  className?: string
  children: React.ReactNode
}

export function FilterDropdown({ show, className, children }: FilterDropdownProps) {
  if (!show) return null

  return (
    <div
      className={cn("selectize-dropdown h-selectize h-selectize--block", className)}
      style={{ position: "static", display: "block" }}
    >
      <div className="selectize-dropdown-content">
        {children}
      </div>
    </div>
  )
}

export interface FilterDropdownGroupProps {
  header?: string
  children: React.ReactNode
}

export function FilterDropdownGroup({ header, children }: FilterDropdownGroupProps) {
  return (
    <div className="optgroup">
      {header && <div className="optgroup-header">{header}</div>}
      {children}
    </div>
  )
}

export interface FilterDropdownOptionProps {
  value: string
  onSelect: (value: string) => void
  children: React.ReactNode
}

export function FilterDropdownOption({
  value,
  onSelect,
  children,
}: FilterDropdownOptionProps) {
  return (
    <div
      className="option"
      data-selectable=""
      data-value={value}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => onSelect(value)}
      onMouseEnter={(e) => e.currentTarget.classList.add("active")}
      onMouseLeave={(e) => e.currentTarget.classList.remove("active")}
    >
      {children}
    </div>
  )
}
